import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getReferralProtocolAPI(referralId: string) {
  return serviceRequest(() => Service.referralControllerGetCurrentUserProtocol(referralId));
}
